import React from "react";
import { Stage, Layer, Group } from "react-konva";
import WheelLamp from "./WheelLamp";

const centerspotUrl = `/wp-content/themes/teamconnector2/assets/images/centerspot.png`;
const spinbaseUrl = `/wp-content/themes/teamconnector2/assets/images/spinbase.png`;
const neckUrl = `/wp-content/themes/teamconnector2/assets/images/Neck.png`;

const WheelSpinner = ({
  diameter,
  isSpinning,
  animateLayer,
  radius,
  animateGroup,
  renderWheelItems
}) => {
  return (
    <div className="v2-wheel-spinner">
      <div className="v2-wheel-spinner__center">
        <picture>
          <source srcSet={centerspotUrl} type="image/png" />
          <img src={centerspotUrl} alt="Center Spot" />
        </picture>
      </div>
      <div className="v2-wheel-spinner-base" style={{ width: diameter }}>
        <div className="v2-wheel-spinner-base-overlay highlight" />
        <div className="v2-wheel-spinner-base-overlay color" />
        <picture>
          <source srcSet={spinbaseUrl} type="image/png" />
          <img src={spinbaseUrl} alt="Union" />
        </picture>
      </div>
      <WheelLamp isSpinning={isSpinning} diameter={diameter} />
      <Stage
        width={diameter}
        height={diameter}
        /**
         * NOTE: it's important to add preventDefault to all konva
         * component to not cancel all the default behaviour (such as
         * scrolling), unless if you litening to specific event.
         *
         * @link https://github.com/konvajs/konva/issues/260#issuecomment-526684995
         */
        preventDefault={false}
      >
        <Layer ref={animateLayer} preventDefault={false}>
          <Group
            y={radius}
            x={radius}
            offset={{ x: radius, y: radius }}
            ref={animateGroup}
            preventDefault={false}
          >
            {renderWheelItems}
          </Group>
        </Layer>
      </Stage>
      <div className="v2-wheel-stand">
        <svg
          className="v2-wheel-stand-overlay highlight"
          width="243"
          height="124"
          viewBox="0 0 243 124"
          fill="currentColor"
        >
          <path d="M25 0H218L243 124H0L25 0Z" fill="currentColor" />
        </svg>

        <svg
          className="v2-wheel-stand-overlay color"
          width="243"
          height="124"
          viewBox="0 0 243 124"
          fill="currentColor"
        >
          <path d="M25 0H218L243 124H0L25 0Z" fill="currentColor" />
        </svg>
        <picture>
          <source srcSet={neckUrl} type="image/png" />
          <img src={neckUrl} alt="Union" />
        </picture>
      </div>
      <div className="v2-wheel__gradient-layer" />
    </div>
  );
};

export default WheelSpinner;
